import React, { PureComponent } from 'react';

import { Text, Wrap } from './styles';

export default class GGText extends PureComponent {
    render() {
        const {
            center,
            lightWeight,
            noMarginTop,
            usualMarginBottom,
            mini,
            error,
            white,
            errorBraintree,
            children,
            html,
        } = this.props;
        return (
            <Text
                center={center}
                lightWeight={lightWeight}
                noMarginTop={noMarginTop}
                usualMarginBottom={usualMarginBottom}
                mini={mini}
                error={error}
                white={white}
                errorBraintree={errorBraintree}
            >
                {!html ? (
                    <Wrap>{children}</Wrap>
                ) : (
                    <Wrap>
                        <div dangerouslySetInnerHTML={{ __html: html }} />
                    </Wrap>
                )}
            </Text>
        );
    }
}
